/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import "./MenuSummaryAlignPicker.css";
import {
  SUMMARY_TEXT_ALIGNS,
  normalizeSummaryTextAlign,
} from "../../../constants/summaryTextAlign";

const ALIGN_LABEL_KEYS = {
  left: "menuSummaryAlignLeft",
  center: "menuSummaryAlignCenter",
  right: "menuSummaryAlignRight",
};

export default function MenuSummaryAlignPicker({ value, onChange, idPrefix = "menu-summary-align" }) {
  const { t } = useTranslation();
  const v = normalizeSummaryTextAlign(value);
  return (
    <div className="menu-summary-align-picker">
      <h3 className="menu-summary-align-picker__title">
        {t("menuSummaryAlignLabel")}
      </h3>
      <p className="menu-summary-align-picker__hint">{t("menuSummaryAlignHint")}</p>
      <div
        className="menu-summary-align-picker__row"
        role="radiogroup"
        aria-label={t("menuSummaryAlignLabel")}
      >
        {SUMMARY_TEXT_ALIGNS.map((align) => (
          <button
            key={align}
            type="button"
            role="radio"
            aria-checked={v === align}
            id={`${idPrefix}-${align}`}
            className={`menu-summary-align-picker__btn ${
              v === align ? "menu-summary-align-picker__btn--active" : ""
            }`}
            onClick={() => onChange(align)}
          >
            {t(ALIGN_LABEL_KEYS[align])}
          </button>
        ))}
      </div>
    </div>
  );
}
